import React from 'react'
import classNames from 'classnames'
import { Select } from '../Select'
import { withStyles } from '@material-ui/core'
import styles from 'Components/ClientDashboard/Components/DashboardsFilters/style'

const SelectV2 = ({
  label,
  options,
  value,
  onChange,
  minWidth = '100%',
  cypress_id = 'SelectV2',
  classes = {},
  style,
}) => {
  return (
    <div
      className={classNames(
        classes.sortWrapper,
        'DashboardsFilters-sortWrapper',
      )}
      style={{
        marginLeft: '0px',
        ...style,
      }}
    >
      <div
        className={classes.selectWrapper}
        style={style?.flex ? { width: '100%' } : undefined}
      >
        <label className={classes.label}>{label}</label>
        <Select
          options={options}
          value={value}
          onChange={onChange}
          minWidth={minWidth}
          cypress_id={cypress_id}
        />
      </div>
    </div>
  )
}

export default withStyles(styles)(SelectV2)
